import { LanguageType, Location, LocationDTO, LocationMapper } from '@nx-smartmonkey/shared/domain';
import axios from 'axios';

import { sessionService } from '../application/SessionService';
import configuration from './configuration';

const post = async (call: any, params: any, headers = {}) => {
  const url = `${configuration.DRIVERS_BACK_END}${call}`;
  return axios.post(url, params, { headers });
};

export const getAutocompleteGeocode = async ({
  searchValue,
  projectId,
  sessionToken,
}: {
  searchValue: string;
  projectId?: string;
  sessionToken?: string;
}): Promise<Location[]> => {
  const params = new URLSearchParams();

  params.append(`query`, searchValue);
  if (projectId) params.append(`project_id`, projectId);
  if (sessionToken) params.append(`session_token`, sessionToken);

  const response = await post(
    `/maps/autocomplete/drivers?${params.toString()}`,
    {},
    {
      Authorization: `Bearer ${await sessionService.getToken()}`,
    }
  );
  return response.status === 200 ? (response.data as LocationDTO[]).map(LocationMapper.toDomain) : [];
};

export const getLocationFromId = async (locationId: any, sessionToken?: string) => {
  const sessionTokenQuery = `${sessionToken ? `&session_token=${sessionToken}` : ``}`;
  const response = await post(
    `/maps/autocomplete/details/drivers?location_id=${locationId}${sessionTokenQuery}`,
    {},
    { Authorization: `Bearer ${await sessionService.getToken()}` }
  );

  return response.status === 200 ? response.data : [];
};

interface GetLocationFromCoordinatesProps {
  coordinates: { lat: number; lng: number }[];
  lang?: LanguageType;
}

export const getLocationFromCoordinates = async ({
  coordinates,
  lang,
}: GetLocationFromCoordinatesProps): Promise<Array<Location>> => {
  const response = await post(
    `/maps/reverse-geocode/drivers`,
    { coordinates, lang },
    {
      Authorization: `Bearer ${await sessionService.getToken()}`,
    }
  );

  if (response.status !== 200) {
    return [];
  }

  const mappedLocations = (response.data as LocationDTO[]).map((loc, index) => {
    return LocationMapper.toDomain(loc ?? coordinates[index]);
  });

  return mappedLocations;
};

export const postGeocode = async ({
  addresses,
  projectId,
}: {
  addresses: string[];
  projectId?: string;
}): Promise<Location[]> => {
  const dataToSend: Record<string, any> = {
    addresses: addresses.map((dir: any) => (!dir || dir === `undefined` ? `` : dir)),
  };

  dataToSend.project_id = projectId ?? ``;

  const response = await post(`/maps/geocode/drivers`, dataToSend, {
    Authorization: `Bearer ${await sessionService.getToken()}`,
  });

  return response.data.map((location: any, idx: number) => {
    // Undefined as string parse.
    return LocationMapper.toDomain({
      ...location,
      original_input: addresses[idx] === `undefined` ? undefined : addresses[idx],
    });
  }) as Location[];
};
